import { ProcessApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';

export default {
	methods: {
		reportProcessChange(processId, action = 'updated') {
			const data = { action: action, process_id: processId, referer: window.location.pathname };
			return ProcessApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios).processLogsPost(data);
		},
	},
};
